import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { message } from "antd";
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";

import {
  hideMessage,
  showMessage,
  getTraineeAllTraining,
  getAllTraining,
  actionBookmarksTraining,
  showModal,
  hideModal,
  showLoader,
} from "./../../appRedux/actions/Training";

import CircularProgress from "components/CircularProgress/index";

import TopNavbar from "./components/TopNavbar";
import CatagoryNavbar from "./components/CatagoryNavbar";
import CatagoryInfo from "./components/CatagoryInfo";
import TrainingTypeInfo from "./components/CatagoryInfo/trainingType";
import TraineeHome from "./home";

import {
  trainerInfo,
  arrCategoryTraining,
  arrCategoryAll,
  arrCategoryPremium,
  arrCategoryCSCU,
} from "./data";

import store from "store";
const style = {
  height: 30,
  border: "1px solid green",
  margin: 6,
  padding: 8,
};

class MainView extends React.PureComponent {
  state = {
    loadingState: false,
    _id: 0,
    clientHeight: 100,
    scrollHeight: 0,
    scrollTop: 0,
    page: 0,
    count: 0,
    changeType: false,
    changePage: false,
    totalRecords: 0,
    trainingInfo: {},
    allTraining: [],
    assignedTraining: [],
    trainingType: "",
    allTrainings: [],
    items: [],
    hasMore: true,
    services: ["training"],
  };

  componentWillMount() {
    const { match } = this.props;
    const { params } = match;
    var user = store.get("user");
    const services = user.organisationId
      ? user.organisationId.services || []
      : [];
    this.setState({ services: services });
    // console.log(user.organisationId.services);
    // const services = services;
    if (params.trainingType) {
      //Assigned / Premium / Standard/ Practice/CSCU
      if (params.trainingType === "Assigned") {
        this.props.showLoader();
        this.props.getTraineeAllTraining({ page: this.state.page });
        this.setState({ _id: 0 });
        this.setState({ trainingType: "Assigned" });
        this.setState({ allTrainings: [] });
      } else if (params.trainingType === "Premium") {
        this.props.showLoader();
        this.props.getAllTraining({ page: this.state.page });
        this.setState({ _id: 1 });
        this.setState({ allTrainings: [] });
      } else if (params.trainingType === "Practice") {
        this.props.showLoader();
        this.props.getAllTraining({ trainingTypeId: 4, page: this.state.page });
        this.setState({
          _id:
            services.includes("premium") || services.includes("standard")
              ? 2
              : 1,
        });
        this.setState({ allTrainings: [] });
      } else if (params.trainingType === "CSCU") {
        this.props.showLoader();
        this.props.getAllTraining({ trainingTypeId: 3, page: this.state.page });
        this.setState({
          _id:
            services.includes("premium") || services.includes("standard")
              ? 3
              : 2,
        });
        this.setState({ allTrainings: [] });
      }
    } else {
      this.props.showLoader();
      this.props.getTraineeAllTraining({ page: this.state.page });
      this.setState({ _id: 0 });
      this.setState({ trainingType: "Assigned" });
      this.setState({ allTrainings: [] });
    }
  }

  componentDidUpdate(prevProps) {
    const { match, pagination } = this.props;
    const { params } = match;
    if (params.trainingType !== prevProps.match.params.trainingType) {
      this.setState({ page: 0 });
      this.callQuery(0);
      this.setState({ allTrainings: [] });
      this.setState({ changeType: true });
    }
  }

  callQuery(page) {
    console.log({ page });
    const { match } = this.props;
    const { params } = match;

    const services = this.state.services;
    console.log("this.props", this.props);
    if (params.trainingType === "Assigned") {
      this.props.showLoader();
      this.props.getTraineeAllTraining({ page: page });
      this.setState({ _id: 0 });
      this.setState({ trainingType: "Assigned" });
    } else if (params.trainingType === "Premium") {
      this.props.showLoader();
      this.props.getAllTraining({ page: page });
      this.setState({ _id: 1 });
      this.setState({ trainingType: "Premium" });
    } else if (params.trainingType === "Practice") {
      this.props.showLoader();
      this.props.getAllTraining({ trainingTypeId: 4, page: page });
      this.setState({
        _id:
          services.includes("premium") || services.includes("standard") ? 2 : 1,
      });
      this.setState({ trainingType: "Practice" });
    } else if (params.trainingType === "CSCU") {
      this.props.showLoader();
      this.props.getAllTraining({ trainingTypeId: 3, page: page });
      this.setState({
        _id:
          services.includes("premium") || services.includes("standard") ? 3 : 2,
      });
      this.setState({ trainingType: "CSCU" });
    }
  }

  loadMore = (nextPage) => {
    console.log(nextPage);
    var self = this;
    this.setState({ page: nextPage }, function() {
      this.callQuery(nextPage);
    });
  };
  componentWillReceiveProps(nextProps) {
    // var {allTraining} = this.props
    this.setState({
      allTrainings: this.state.allTrainings.concat(nextProps.allTraining),
    });
  }
  render() {
    const {
      match,
      pagination,
      bookmarkInfo,
      allTraineeTraining,
      allTraining,
      loader,
      successMessage,
      showMessage,
      alertMessage,
    } = this.props;
    const { params } = match;
    var self = this;

    const services = this.state.services;
    var arrCategory = arrCategoryAll;
    if (
      (services.includes("premium") || services.includes("standard")) &&
      (services.includes("CSCU") || services.includes("cscu"))
    ) {
      arrCategory = arrCategoryAll;
    } else if (services.includes("premium") || services.includes("standard")) {
      arrCategory = arrCategoryPremium;
    } else if (services.includes("CSCU") || services.includes("cscu")) {
      arrCategory = arrCategoryCSCU;
    } else {
      arrCategory = arrCategoryTraining;
    }
    if (params.trainingType === "Assigned") {
      this.setState({ _id: 0 });
      this.setState({ trainingType: "Assigned" });
    } else if (params.trainingType === "Premium") {
      this.setState({ _id: 1 });
      this.setState({ trainingType: "Premium" });
    } else if (params.trainingType === "Practice") {
      this.setState({
        _id:
          services.includes("premium") || services.includes("standard") ? 2 : 1,
      });
      this.setState({ trainingType: "Practice" });
    } else if (params.trainingType === "CSCU") {
      this.setState({
        _id:
          services.includes("premium") || services.includes("standard") ? 3 : 2,
      });
      this.setState({ trainingType: "CSCU" });
    }
    var assignedTraining = [];
    if (allTraineeTraining.length > 0) {
      assignedTraining = allTraineeTraining.filter(
        (item) => item.campaignId.trainingId
      );
    }

    if (bookmarkInfo) {
      if (bookmarkInfo.campaignId) {
        assignedTraining[bookmarkInfo.index] = bookmarkInfo;
      } else {
        allTraining[bookmarkInfo.index] = bookmarkInfo;
      }
    }
    const trainingType = (type) => {
      return this.props.history.push("/trainee/" + type);
    };
    const catagoryInfoProps = {
      loader: loader,
      pagination: pagination,
      allTraining: assignedTraining, //assignedTraining,
      trainerInfo: trainerInfo,
      trainingType: params.trainingType,
      bookmarksAction: (action, index, info) => {
        info["index"] = index;
        this.props.actionBookmarksTraining({
          trainingId: info.campaignId.trainingId._id,
          action: action,
          trainingInfo: info,
        });
      },
    };
    const trainingTypeInfoProps = {
      loader: loader,
      pagination: pagination,
      allTraining: this.state.allTrainings, //allTraining,
      trainerInfo: trainerInfo,
      trainingType: params.trainingType,
      fetchMoreData: (info) => {
        this.props.showLoader();
        this.props.getAllTraining({ page: pagination + 1 });
      },
      bookmarksAction: (action, index, info) => {
        info["index"] = index;
        this.props.actionBookmarksTraining({
          trainingId: info._id,
          action: action,
          trainingInfo: info,
        });
      },
    };

    return (
      <div>
        {loader || this.state.loadingState ? (
          <div
            style={{
              position: "absolute",
              zIndex: "+111",
              left: "45%",
              top: "15%",
            }}
          >
            <CircularProgress />
          </div>
        ) : null}
        {showMessage
          ? alertMessage
            ? message.error(alertMessage.toString())
            : null
          : null}
        {showMessage
          ? successMessage
            ? message.success(successMessage.toString())
            : null
          : null}
        <div>
          <TopNavbar key="topNavbarKey" />
          <ul key="catagory-navbar" className="uk-switcher switcher-container">
            {arrCategory &&
              arrCategory.map((categoryInfo, index) => {
                return (
                  <li className={index === this.state._id ? "uk-active" : ""}>
                    <CatagoryNavbar
                      categoryInfo={categoryInfo}
                      index={index + 1}
                    />
                  </li>
                );
              })}
          </ul>
          <button
            className="uk-button uk-hidden@m  mobile-catagory-button"
            type="button"
            data-uk-toggle="target: #tabs-moible; cls: tabs-moible"
          >
            {" "}
            Open subcatagory{" "}
          </button>

          <ul
            key="mob"
            className="uk-subnav uk-subnav-pill tabs-moible-hidden"
            data-uk-switcher="connect: .switcher-container"
            data-uk-tab="{connect:'#my-id2'}"
            id="tabs-moible"
          >
            {arrCategory &&
              arrCategory.map((categoryInfo, index) => {
                return (
                  <li
                    className={index == this.state._id ? "uk-active" : ""}
                    onClick={() => {
                      trainingType(categoryInfo._id);
                    }}
                  >
                    <Link
                      to={{
                        pathname: "/trainee/" + categoryInfo._id,
                        state: {
                          _id: index,
                        },
                      }}
                    >
                      {" "}
                      {categoryInfo.categoryNav}{" "}
                    </Link>
                  </li>
                );
              })}
          </ul>
        </div>
        <ul
          key="CatagoryInfo"
          id="my-id2"
          className="uk-switcher switcher-container uk-margin"
        >
          {!loader &&
            arrCategory &&
            arrCategory.map((categoryInfo, index) => {
              return (
                <li className={index == this.state._id ? "uk-active" : ""}>
                  {index == 0 ? (
                    <CatagoryInfo
                      index={index}
                      categoryInfo={categoryInfo}
                      {...catagoryInfoProps}
                    />
                  ) : (
                    <TrainingTypeInfo
                      index={index}
                      categoryInfo={categoryInfo}
                      {...trainingTypeInfoProps}
                    />
                  )}
                </li>
              );
            })}
        </ul>
      </div>
    );
  }
}
const mapStateToProps = ({ auth, trainingInfo }) => {
  const { authUser, accessToken } = auth;
  const {
    loader,
    alertMessage,
    successMessage,
    showMessage,
    allTraining,
    allTraineeTraining,
    bookmarkInfo,
    pagination,
  } = trainingInfo;
  return {
    loader,
    alertMessage,
    successMessage,
    showMessage,
    authUser,
    accessToken,
    allTraineeTraining,
    allTraining,
    bookmarkInfo,
    pagination,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    {
      hideMessage,
      showMessage,
      getTraineeAllTraining,
      getAllTraining,
      actionBookmarksTraining,
      showModal,
      hideModal,
      showLoader,
    }
  )(MainView)
);
